import BaseCadastro from "components/BaseCadastro";
import { Label } from "components/input/Label";
import FormaPagamento from "model/fiscal/FormaPagamento";
import { Checkbox } from "primereact/checkbox";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { useState } from "react";
import FormaPagamentoService from "service/fiscal/FormaPagamentoService";

const formaPagamentoService = new FormaPagamentoService();

export default function FormaPagamentoCadastro() {
    const [formaPagamento, setFormaPagamento] = useState<FormaPagamento>(new FormaPagamento());
    const [erro, setErro] = useState("");

    function validar() {
        if (!formaPagamento.codigoInterno) {
            setErro("Preencha o campo Código.");
            return false;
        }
        if (!formaPagamento.descricao) {
            setErro("Preencha o campo Descrição.");
            return false;
        }
        if (!formaPagamento.tipoPagamentoNfe) {
            setErro("Preencha o campo Tipo de pagamento NF-e.");
            return false;
        }
        if (!/^\d{2}$/.test(formaPagamento.tipoPagamentoNfe)) {
            setErro("O tipo de pagamento NF-e deve conter 2 dígitos.");
            return false;
        }
        setErro("");
        return true;
    }

    return (
        <BaseCadastro model={formaPagamento} service={formaPagamentoService}
            setModel={(value: FormaPagamento) => setFormaPagamento(value)}
            getNewModel={() => new FormaPagamento()} novoCadastro
            validar={validar} pathCadastro="/formaPagamento" urlService="/formaPagamento" tituloPagina="Forma de pagamento">
            <div className="row">
                <label style={{ fontSize: 18, fontWeight: 'bold' }} className="col col-sm-12">Forma de pagamento</label>
            </div>
            <div className="row">
                <div className="col-12 mb-3">
                    <Checkbox inputId="formaPagamento-ativo" checked={formaPagamento.ativa}
                        onChange={(e) => setFormaPagamento({ ...formaPagamento, ativa: !!e.checked })} />
                    <label htmlFor="formaPagamento-ativo" style={{ marginLeft: 8 }}>Ativo</label>
                </div>
                <div className="col-12 mb-3">
                    <Label obrigatorio>Código</Label>
                    <InputText value={formaPagamento.codigoInterno ?? ""} maxLength={10}
                        onChange={(e) => { setFormaPagamento({ ...formaPagamento, codigoInterno: e.target.value }); setErro(""); }}
                        style={{ width: "100%" }} />
                </div>
                <div className="col-12 mb-3">
                    <Label obrigatorio>Descrição</Label>
                    <InputText value={formaPagamento.descricao ?? ""} maxLength={30}
                        onChange={(e) => { setFormaPagamento({ ...formaPagamento, descricao: e.target.value }); setErro(""); }}
                        style={{ width: "100%" }} />
                </div>
                <div className="col-12 mb-3">
                    <Label>Abreviatura</Label>
                    <InputText value={formaPagamento.abreviatura ?? ""} maxLength={10}
                        onChange={(e) => { setFormaPagamento({ ...formaPagamento, abreviatura: e.target.value }); setErro(""); }}
                        style={{ width: "100%" }} />
                </div>
                <div className="col-12 mb-3">
                    <Label obrigatorio>Tipo de pagamento NF-e</Label>
                    <Dropdown value={formaPagamento.tipoPagamentoNfe ?? ""} 
                        itemTemplate={(option) => <span>{option.label} ({option.value})</span>}
                        filter filterBy="label,value"
                        options={formaPagamentoService.getTiposPagamentoNfe()}
                        onChange={(e) => { setFormaPagamento({ ...formaPagamento, tipoPagamentoNfe: e.value }); setErro(""); }}
                        style={{ width: "100%" }} />
                </div>
            </div>
            {erro && <small className="p-error">{erro}</small>}
        </BaseCadastro>
    );
}
